<div *ngIf="!showPreview" class="add-google-slide-wrapper w-full" [id]="data?.layoutData?.uuid">
  <app-text-input (checkForErrors)="checkForErrors($event)" [error]="errorMessages['googleSlideUrl']"
    [maxLength]="100000" [parentFormGroup]="googleSlidesForm" class="resource-input" controlName="googleSlideUrl"
    placeholder="Enter Presentation URL" type="small"></app-text-input>
</div>

<div *ngIf="showPreview" class="add-google-slide-wrapper-preview w-full" [id]="data?.layoutData?.uuid">
  <div class="w-full flex items-center input-wrapper justify-around">
    <div class="w-[85%]">
      <app-text-input (checkForErrors)="checkForErrors($event)" [error]="errorMessages['googleSlideUrl']"
        [maxLength]="100000" [parentFormGroup]="googleSlidesForm" [readonly]="false" class="preview-input"
        controlName="googleSlideUrl" placeholder="Enter Presentation URL" type="small"></app-text-input>
    </div>
    <div class="w-[10%]">
      <app-icon (click)="deleteGoogleSlidesLink()" class="delete-bold-icon cursor-pointer"
        svgIcon="delete-bold"></app-icon>
    </div>
  </div>
  <div *ngIf="layoutData.googleSlideUrl.length>0 && showPreview"
    [innerHTML]="getSanitizedContent(layoutData.googleSlideUrl)" class="slide-wrapper-{{UUID}} preview"></div>
</div>